(function() { window.GUID_b7d22c33_25db_48e2_8a57_1eaa2e778d45 = { getGuid: function() { return "b7d22c33-25db-48e2-8a57-1eaa2e778d45"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class PersonaPicker extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.redirectUrl = params[1];
                this.showDrawerUrl = params[2];
                this.showPersonaWallSelector = params[3];
                this.personaId = params[4];
                this.redirectUrlIfNotInEvent = params[5];
            }
            OnBindEvents() {
                this.$Control.offon(`click.${this.ControlId}`, (e) => {
                    this.handlePickerClick(e);
                });
                Controls.Popup.Events.PopupShow({
                    selector: "body",
                    childSelector: `#popup-persona-picker${this.ControlId}`,
                    callback: (popup, e) => {
                        this.drawer = new PersonaPickerDrawer(popup, this);
                    },
                });
                Controls.Popup.Events.PopupClose({
                    selector: "body",
                    childSelector: `#popup-persona-picker${this.ControlId}`,
                    callback: (popup, e) => {
                        if (this.drawer != null) {
                            this.drawer.dispose();
                            this.drawer = null;
                        }
                    },
                });
            }
            OnDispose() {
                // Don't dispose the drawer here — its popup may still be visible
                // (e.g. when the parent popup closes before the drawer popup).
                // The PopupClose event handler will dispose the drawer when its popup closes.
                this.drawer = null;
            }
            OnControlRendered() { }
            CloseDropDown() {
                if (Controls.Popup.CurrentModal) {
                    Controls.Popup.CurrentModal.Close();
                }
            }
            handlePickerClick(e) {
                e.preventDefault();
                CS.Analytics.Event("Personas", "Persona picker clicked", `Wall - ${CS.Helper.GetWallTypeString(CS.CommonData.Current.Navigation.WallType)}`, CS.CommonData.Current.Navigation.WallType);
                if (this.$Control.hasClass("disabled")) {
                    return;
                }
                if (this.showPersonaWallSelector.toLowerCase() == "true") {
                    const personaIsInEventUrl = CS.Url.CSUrl("PersonaIsInEvent");
                    const personaWallSelectorUrl = CS.Url.CSUrl("PersonaWallSelector");
                    const showPersonaWallSelectorPopup = () => {
                        const _url = personaWallSelectorUrl.replace("_____", this.personaId);
                        Controls.Popup.ShowAjaxModal(_url, {}, () => { }, () => { }, true);
                    };
                    if (personaIsInEventUrl != null) {
                        const _url = personaIsInEventUrl.replace("_____", this.personaId);
                        CS.Ajax.Get(_url, null, (response) => {
                            const { isInEvent, personaWallUrl } = response;
                            if (personaWallUrl != null &&
                                typeof personaWallUrl === "string" &&
                                typeof isInEvent === "boolean" &&
                                isInEvent == false) {
                                CS.Nav.Go(personaWallUrl);
                            }
                            else {
                                showPersonaWallSelectorPopup();
                            }
                        });
                    }
                    else if (personaWallSelectorUrl != null) {
                        showPersonaWallSelectorPopup();
                    }
                }
                else if (!CS.Helper.isNullOrWhiteSpace(this.showDrawerUrl)) {
                    try {
                        const sportsIds = this.$Control.attr("data-persona-sports");
                        if (!CS.Helper.isNullOrWhiteSpace(sportsIds)) {
                            const sportsIdsArray = sportsIds.split(",").map((x) => x.trim());
                            if (sportsIdsArray.length) {
                                const sportsIdsParam = sportsIdsArray.join(",");
                                this.showDrawerUrl = CS.Url.AddOrUpdateQueryStringParameter(this.showDrawerUrl, "sportsIds", sportsIdsParam);
                            }
                        }
                    }
                    catch (error) {
                        console.error("Error adding sports ids to the url", error);
                    }
                    const selectedPersonaId = this.$Control.attr("data-selected-persona-id");
                    if (selectedPersonaId !== undefined) {
                        const drawerUrl = new URL(this.showDrawerUrl, window.location.origin);
                        const personaIdKeys = [];
                        drawerUrl.searchParams.forEach((_, key) => {
                            if (key.toLowerCase() === "personaid") {
                                personaIdKeys.push(key);
                            }
                        });
                        personaIdKeys.forEach((key) => drawerUrl.searchParams.delete(key));
                        drawerUrl.searchParams.set("PersonaId", selectedPersonaId);
                        this.showDrawerUrl = drawerUrl.pathname + drawerUrl.search;
                    }
                    Controls.Popup.ShowAjaxModal(this.showDrawerUrl, {
                        pickerControlId: this.ControlId
                    }, 
                    // On load
                    ({ popup, isPopup }) => { }, 
                    // On close
                    ({ popup }) => { }, true, true, true);
                }
            }
            handleAutocompleteItemClick(e, personaId, picker, pickerEvent, name, avatar) {
                var _a, _b;
                const { isInEvent, personaWallUrl } = (_b = (_a = pickerEvent.data[0]) === null || _a === void 0 ? void 0 : _a.extraValues) !== null && _b !== void 0 ? _b : {};
                let forceRedirectToUrl = "";
                try {
                    const { WallType } = CS.CommonData.Current.Navigation;
                    if (WallType == CS.Enumeration.WallType.EventWall) {
                        if (!isInEvent) {
                            forceRedirectToUrl = personaWallUrl;
                        }
                    }
                }
                catch (error) {
                    console.error(error);
                }
                this.handlePersonaItemClick(e, personaId, forceRedirectToUrl, name, avatar);
                //Clear selected item in the dropdown so we can reselect the same item
                picker.DropDown.$SelectedItems.removeClass("selected");
            }
            handlePersonaItemClick(e, personaId, forceRedirectToUrl = null, name, avatar, sportsIds) {
                let isInCurrentEvent = true;
                if (e != null) {
                    e.preventDefault();
                    const $personaItem = $(e.currentTarget).closest(".item");
                    if ($personaItem.length) {
                        personaId = $personaItem.data("persona-id");
                        isInCurrentEvent = $personaItem.data("is-in-current-event") == "True";
                        sportsIds = $personaItem.data("sports");
                    }
                }
                if (forceRedirectToUrl != null &&
                    !CS.Helper.isNullOrWhiteSpace(forceRedirectToUrl)) {
                    CS.Nav.Go(forceRedirectToUrl);
                }
                else if (!CS.Helper.isNullOrWhiteSpace(personaId)) {
                    CS.Analytics.Event("Personas", "Persona picker item clicked", `Wall - ${CS.Helper.GetWallTypeString(CS.CommonData.Current.Navigation.WallType)}`, CS.CommonData.Current.Navigation.WallType);
                    const shouldRedirect = e == null || !$(e.currentTarget).hasClass("selected");
                    if (!isInCurrentEvent &&
                        !CS.Helper.isNullOrWhiteSpace(this.redirectUrlIfNotInEvent)) {
                        if (shouldRedirect) {
                            const url = this.redirectUrlIfNotInEvent.replace("_____PERSONAID_____", personaId);
                            CS.Nav.Go(url);
                        }
                    }
                    else if (!CS.Helper.isNullOrWhiteSpace(this.redirectUrl)) {
                        if (shouldRedirect) {
                            const url = this.redirectUrl.replace("_____PERSONAID_____", personaId);
                            CS.Nav.Go(url);
                        }
                    }
                    else {
                        this.Trigger(PersonaPicker.EventNames.PersonaItemClicked, {
                            jqueryEventObject: e,
                            data: { personaId, name, avatar, sportsIds },
                        });
                    }
                }
            }
            computeStickyTopValues(popup) {
                if (popup != null && popup.$Control.length) {
                    const $headerSection = popup.$Control.find(".header-section");
                    const $sectionHeaders = popup.$Control.find(".section__header");
                    const $tabmenu = popup.$Control.find("#tabmenu-persona-picker");
                    if ($tabmenu.length) {
                        const tabmenuStickyTop = $headerSection.length
                            ? $headerSection.outerHeight() - 0.5
                            : 0;
                        $tabmenu.css({
                            position: "sticky",
                            top: tabmenuStickyTop,
                            zIndex: 1,
                        });
                    }
                    if ($headerSection.length && $sectionHeaders.length) {
                        let top = $headerSection.outerHeight() - 0.5;
                        if ($tabmenu.length) {
                            top += $tabmenu.outerHeight();
                        }
                        $sectionHeaders.each((index, element) => {
                            $(element).css({ position: "sticky", top });
                        });
                    }
                }
            }
        }
        Controls.PersonaPicker = PersonaPicker;
        (function (PersonaPicker) {
            class Events {
                static PersonaItemClicked(param) {
                    Controls.RegisterEvent(PersonaPicker, EventNames.PersonaItemClicked, param);
                }
            }
            PersonaPicker.Events = Events;
            class EventNames {
            }
            EventNames.PersonaItemClicked = "persona-item-clicked";
            PersonaPicker.EventNames = EventNames;
        })(PersonaPicker = Controls.PersonaPicker || (Controls.PersonaPicker = {}));
        class PersonaPickerDrawer {
            constructor(popup, picker) {
                this.popup = popup;
                this.picker = picker;
                this.eventNamespace = Controls.GetNewUniqueEventNamespace();
                this.resizeEventNamespace = `resize.personapicker-${this.eventNamespace}`;
                this.tabmenuEventNamespace = `click.${this.eventNamespace}-tabmenu`;
                this.itemClickEventNamespace = `click.${this.eventNamespace}-item`;
                this.autocompleteEventBaseNamespace = `${Controls.DropDownPicker.EventNames.PickerSelectionChanged}.${this.eventNamespace}`;
                this.bindEvents();
            }
            sanitizeSelectorForNamespace(selector) {
                return selector.replace(/[^a-z0-9\-]|^[^a-z]+/g, "");
            }
            getAutocompleteEventNamespace(selector) {
                return `${this.autocompleteEventBaseNamespace}-${this.sanitizeSelectorForNamespace(selector)}`;
            }
            bindAutocompleteSelection(selector) {
                const eventNamespace = this.getAutocompleteEventNamespace(selector);
                this.popup.$Control.offon(eventNamespace, selector, (jqueryEvent, pickerEvent) => {
                    var _a, _b, _c, _d, _e, _f;
                    if (this.picker == null || pickerEvent == null) {
                        return;
                    }
                    const picker = CS.Controls.GetInstance(CS.Controls.DropDownPicker, $(jqueryEvent.currentTarget), true);
                    if (picker == null) {
                        return;
                    }
                    const { updateLastSearchUrl } = (_b = (_a = pickerEvent.data[0]) === null || _a === void 0 ? void 0 : _a.extraValues) !== null && _b !== void 0 ? _b : {};
                    if (updateLastSearchUrl) {
                        CS.Ajax.Post(updateLastSearchUrl, {});
                    }
                    const innerText = (_d = (_c = pickerEvent.data[0]) === null || _c === void 0 ? void 0 : _c.innerText) !== null && _d !== void 0 ? _d : "";
                    let name = "";
                    let avatar = "";
                    if (!CS.Helper.isNullOrWhiteSpace(innerText)) {
                        const $innerText = $(innerText);
                        if ($innerText.length) {
                            const $name = $innerText.find(".data__header .name");
                            if ($name.length) {
                                name = $name.text();
                                if (!CS.Helper.isNullOrWhiteSpace(name)) {
                                    name = name.trim();
                                }
                            }
                            const $avatar = $innerText.find(".avatar img");
                            if ($avatar.length) {
                                avatar = $avatar.attr("src");
                            }
                        }
                    }
                    this.picker.handleAutocompleteItemClick(null, (_f = (_e = pickerEvent.data[0]) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : "", picker, pickerEvent, name, avatar);
                });
            }
            bindEvents() {
                try {
                    if (!this.popup.$Control.length) {
                        Controls.ScriptErrorLogger.DisplayError({
                            message: "Popup control not found",
                            file: "persona-picker.ts",
                        });
                        throw new Error("Popup control not found");
                    }
                    this.bindItemClick();
                    this.bindAutocompletes();
                    this.bindResize();
                    this.bindTabmenu();
                }
                catch (error) {
                    console.error("Error while binding events of PersonaPickerDrawer", error);
                }
            }
            bindTabmenu() {
                try {
                    this.$tabmenu = this.popup.$Control.find("#tabmenu-persona-picker");
                    if (!this.$tabmenu.length) {
                        return;
                    }
                    this.popup.$Control.offon(this.tabmenuEventNamespace, "#tabmenu-persona-picker .tab-menu-item", this.handleTabmenuClick.bind(this));
                    this.sortItems();
                }
                catch (error) {
                    console.error("Error while binding tabmenu events", error);
                }
            }
            sortItems() {
                try {
                    const $activeTab = this.$tabmenu.find(".tab-menu-item.is-highlighted");
                    if (!$activeTab.length) {
                        return;
                    }
                    const extraData = $activeTab.data("html");
                    if (!extraData || typeof extraData.personaType === "undefined") {
                        return;
                    }
                    const $items = this.popup.$Control.find(".item");
                    $items.each((index, element) => {
                        const personaType = $(element).data("persona-type");
                        if (isNaN(personaType)) {
                            return;
                        }
                        if (personaType == extraData.personaType) {
                            $(element).show();
                        }
                        else {
                            $(element).hide();
                        }
                    });
                }
                catch (error) {
                    console.error("Error while sorting items", error);
                }
            }
            handleTabmenuClick(e) {
                try {
                    CS.Helper.log("PersonaPickerDrawer", "Handling tabmenu click event");
                    const $activeTab = this.$tabmenu.find(".tab-menu-item.is-highlighted");
                    const $clickedTab = $(e.currentTarget);
                    if ($activeTab.is($clickedTab)) {
                        return;
                    }
                    $activeTab.removeClass("is-highlighted");
                    $clickedTab.addClass("is-highlighted");
                    this.sortItems();
                }
                catch (error) {
                    console.error("Error while handling tabmenu click events", error);
                }
            }
            bindResize() {
                try {
                    if (this.picker == null || this.popup == null) {
                        return;
                    }
                    this.picker.computeStickyTopValues(this.popup);
                    CS.DOM.$win.offon(this.resizeEventNamespace, () => {
                        CS.Lag(`resizepersonapicker-${this.eventNamespace}`, 150, () => {
                            if (this.picker != null) {
                                this.picker.computeStickyTopValues(this.popup);
                            }
                        });
                    });
                }
                catch (error) {
                    console.error("Error while binding resize events", error);
                }
            }
            bindAutocompletes() {
                try {
                    if (this.popup.$Control.find(".autocomplete-container").length) {
                        this.bindAutocompleteSelection("#autocomplete-find-players-persona-picker");
                        this.bindAutocompleteSelection("#autocomplete-find-opponents-persona-picker");
                        this.bindAutocompleteSelection("#autocomplete-find-teams-persona-picker");
                    }
                }
                catch (error) {
                    console.error("Error while binding autocompletes", error);
                }
            }
            bindItemClick() {
                try {
                    this.popup.$Control.offon(this.itemClickEventNamespace, ".item:not(.disabled) .inner-content", (e) => {
                        const $itemContainer = $(e.currentTarget).closest(".item");
                        if ($itemContainer.length) {
                            const updateLastSearchUrl = $itemContainer.data("updatelastsearchurl");
                            if (updateLastSearchUrl) {
                                CS.Ajax.Post(updateLastSearchUrl, {});
                            }
                        }
                        if (!$(e.currentTarget).hasClass("cs-popup-auto-trigger")) {
                            let name = "";
                            let avatar = "";
                            let sportsIds = "";
                            const $name = $itemContainer.find(".title");
                            if ($name.length) {
                                name = $name.text();
                                if (!CS.Helper.isNullOrWhiteSpace(name)) {
                                    name = name.trim();
                                }
                            }
                            const $avatar = $itemContainer.find(".pic-helper-img-container img");
                            if ($avatar.length) {
                                avatar = $avatar.attr("src");
                            }
                            sportsIds = $itemContainer.data("sports");
                            if (this.picker == null) {
                                return;
                            }
                            this.picker.handlePersonaItemClick(e, "", "", name, avatar, sportsIds);
                        }
                    });
                }
                catch (error) {
                    console.error("Error while binding item click events", error);
                }
            }
            dispose() {
                try {
                    if (this.popup != null && this.popup.$Control != null) {
                        this.popup.$Control.off(this.tabmenuEventNamespace);
                        this.popup.$Control.off(this.itemClickEventNamespace);
                        this.popup.$Control.off(this.getAutocompleteEventNamespace("#autocomplete-find-players-persona-picker"));
                        this.popup.$Control.off(this.getAutocompleteEventNamespace("#autocomplete-find-opponents-persona-picker"));
                        this.popup.$Control.off(this.getAutocompleteEventNamespace("#autocomplete-find-teams-persona-picker"));
                    }
                    CS.DOM.$win.off(this.resizeEventNamespace);
                    this.$tabmenu = null;
                    this.popup = null;
                    this.picker = null;
                }
                catch (error) {
                    console.error("Error while disposing PersonaPickerDrawer", error);
                }
            }
        }
        Controls.PersonaPickerDrawer = PersonaPickerDrawer;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=persona-picker.js.map
